var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShuffle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5l2.5 2.5m0 0L14 16.5m2.5-2.5h-2.026c-.783 0-1.174 0-1.53-.108a2.502 2.502 0 01-.86-.46c-.287-.236-.504-.562-.938-1.213l-.202-.302M14 1.5L16.5 4m0 0L14 6.5M16.5 4h-2.026c-.783 0-1.174 0-1.53.108a2.5 2.5 0 00-.86.46c-.287.236-.504.562-.938 1.213L6.854 12.22c-.434.651-.651.977-.938 1.212a2.501 2.501 0 01-.86.461C4.7 14 4.308 14 3.525 14H1.5m0-10h2.026c.783 0 1.174 0 1.53.108a2.5 2.5 0 01.86.46c.287.236.504.562.938 1.213l.202.302",
    stroke: "#000",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgShuffle;